import { Category } from '../models/EventModel';

export function getEventCategoryLabel(categories: Category[], selectedCategories = ''): string {
    if (categories.length === 0) return '';
    if (categories.length === 1) return categories[0].name;

    const selectedSlugs = selectedCategories.split(';').filter(Boolean);
    const matchedCategory = categories.find((category) => selectedSlugs.includes(category.slug));
    const category = matchedCategory ?? categories[0];

    return `${category.name} +${categories.length - 1}`;
}
